// extracted by mini-css-extract-plugin
export default {"acro":"styles_acro__cUhFY","select":"styles_select__soIQY"};